export function offsetToZone(offset) {
  if (offset < 0) {
    return `UTC-${Math.abs(offset)}`; // I want to control the minus char
  }
  if (offset === 0) {
    return "UTC";
  }
  return `UTC+${Math.abs(offset)}`;
}

export function defaultZone() {
  return (
    $.cookie("search-timezone") ||
    offsetToZone(0 - new Date().getTimezoneOffset() / 60)
  );
}

// Formats a date picker's selection for a search token. Pikaday's own
// `toString` only produces this format when it can see moment as a function,
// which it cannot in the production bundle, so format the date ourselves.
export function formatTokenDate(date) {
  const pad = (n) => String(n).padStart(2, "0");
  return [
    date.getFullYear(),
    pad(date.getMonth() + 1),
    pad(date.getDate()),
  ].join("-");
}

export function zoneToOffset(zone) {
  if (zone === "UTC") {
    return 0;
  }
  const offset = parseInt(zone.split("+")[1] || zone.split("-")[1], 10);
  return zone.includes("-") ? -offset : offset;
}
